import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { resolveImageUrl } from "@/lib/api";

function initials(name = "?") {
  return name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

/**
 * Avatar with an optional gold ring for verified scholars. Same DOM as a
 * plain <Avatar/> so it drops in anywhere; the ring is a subtle box-shadow
 * so it never shifts layout.
 */
export default function ScholarAvatar({
  user,
  size = 44,
  className = "",
  fallbackClassName = "",
  showRing = true,
}) {
  const px = `${size}px`;
  const verified = !!user?.verified;
  const ringStyle = verified && showRing
    ? { boxShadow: "0 0 0 2px var(--ayur-cream), 0 0 0 4px var(--ayur-gold)" }
    : undefined;
  return (
    <Avatar
      data-testid={verified ? "scholar-avatar-verified" : "scholar-avatar"}
      title={verified ? "Verified BAMS scholar" : undefined}
      className={`border border-[color:var(--ayur-border)] ${className}`}
      style={{ width: px, height: px, ...ringStyle }}
    >
      <AvatarImage src={resolveImageUrl(user?.avatar_url)} />
      <AvatarFallback
        className={`bg-[color:var(--ayur-badge)] text-[color:var(--ayur-emerald)] font-semibold ${fallbackClassName}`}
      >
        {initials(user?.full_name)}
      </AvatarFallback>
    </Avatar>
  );
}
